/**
 * Classes of the grid's first two columns, which stay at the left edge when
 * the grid scrolls. Each `left-*` offset is the sum of the widths before it.
 */
export const NUMBER_CELL =
  "sticky left-0 w-10 min-w-10 max-w-10 border-b border-r border-zinc-200";
export const ROW_CELL =
  "sticky left-10 w-40 min-w-40 max-w-40 border-b border-r border-zinc-200";
/** Its scroll margins keep a cell that scrolls into view clear of the sticky header and columns. */
export const VALUE_CELL =
  "min-w-36 max-w-64 scroll-mt-16 scroll-ml-50 scroll-mr-9 border-b border-r last:border-r-0";
/**
 * For the button of a cell: its `::before` covers the cell, so a click anywhere in the
 * cell reaches it. The cell must be `relative` or `sticky`. Elements in the button, and
 * other buttons in the cell, need `relative` to stay above the cover. Each use adds a
 * ring color.
 */
export const CELL_BUTTON =
  "before:absolute before:inset-0 before:content-[''] focus-visible:outline-none focus-visible:before:ring-2 focus-visible:before:ring-inset";
/** The last column, with the Add column button; it stays at the right edge. */
export const ADD_COLUMN_CELL =
  "sticky right-0 w-9 min-w-9 max-w-9 border-b border-l border-zinc-200";
